import { Reveal } from "@/components/Reveal";
import { PRICING, formatCr } from "@/constants/content";
import { LeadCTAs } from "@/components/LeadCTAs";

export const Pricing = () => (
  <section id="pricing" className="cp-section cp-section--navy" data-testid="pricing-section">
    <div className="cp-container cp-pricing-grid cp-pricing-grid--single">
      <Reveal>
        <span className="cp-eyebrow gold">Pricing</span>
        <h2 className="cp-h2 light">Exclusive Pre-Launch Offer</h2>
        <div className="cp-price-hero">
          <strong>{formatCr(PRICING.fromCr)}</strong>
          <span>starting estimate · up to {formatCr(PRICING.upToCr)}</span>
        </div>
        <p className="cp-price-plc">
          Indicative all-in pre-launch pricing for SCO units. Final quotes are shared one-on-one with our sales team.
        </p>
        <LeadCTAs
          theme="dark"
          className="cp-price-ctas"
          enquireTestId="pricing-request-price-btn"
          waTestId="pricing-whatsapp-btn"
          enquireLabel="Request Price"
        />
      </Reveal>

      {/* Price calculator widget hidden
      <Reveal delay={0.15} className="cp-calculator" data-testid="price-calculator">...</Reveal>
      */}
    </div>
  </section>
);
